// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ocdl","banner":"d_Hzl","title":"_2uyO0","subTitle":"_2lJNV","text1":"_1NJdC","learnButton":"_1AF4M","bannerBg":"_2BV_a","bg1":"_1VPV9"};